/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar } from '../../../state/slices/app';
// material
import { MultiSelectDropDown } from '@insticator/insticator-ui';

import Controls from './controls/controls';
import Nav from './nav/nav';
import NavBeta from "./nav/nav_beta";
import User from './user/user';
import Switch from './switch/switch';
// styles
import injectSheet from 'react-jss';
import styles from './sidebar_styles';



/* ========== ~~~~~~~~~~ SIDEBAR ~~~~~~~~~~ ========== */
const Sidebar = injectSheet(styles)((props) => {
	const dispatch = useDispatch();
	const sidebarOpen = useSelector(state => state.app.sidebarOpen);
	const sidebarLocked = useSelector(state => state.app.sidebarLocked);
	const handleMouseEnter = (e) => sidebarLocked || dispatch(toggleSidebar(true));
	const handleMouseLeave = (e) => sidebarLocked || dispatch(toggleSidebar(false));

	const accountName = useSelector((state) => state.account.accountName)
	const mocked = useSelector(state => state.session.mocked);

	const hideSidebar = window.location.href.includes('dashboard/commenting/import/preview')

	const getAccounts = () => [
		{value: accountName, name: accountName},
		{value: 'ACCOUNT', name: 'account'} // Just a placeholder to show the actual company. Will remove once there's multiple accounts.
	];
	return !hideSidebar && (
		<aside id="sidebar" className={`${props.classes.sidebar} sidebarOpen-${sidebarOpen}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<Controls />
			{mocked &&
			<div className={`sidebarOpen-${sidebarOpen} filter-company`}>
				<div className={'name'}>Company</div>
				<div className={'title'} title={accountName}>{accountName}</div>
			</div>
			}
			<NavBeta/>
			<User />
			<Switch />
		</aside>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Sidebar;
